import type { IconTextList as UniclientIconTextList } from '@lemonade-hq/uniclient-chat';
import { Flex, spacing } from '@lemonade-hq/uniclient-theme';
import { AnimatePresence, motion } from 'motion/react';
import React from 'react';
import { IconTextRow } from './IconTextRow/IconTextRow';

const animationVariants = {
  initial: {
    opacity: 0,
    height: 0,
  },
  animate: {
    opacity: 1,
    height: 'auto',
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export interface IconTextListProps {
  readonly items: UniclientIconTextList;
  readonly size?: 'md' | 'sm';
  readonly withAnimation?: boolean;
  readonly ariaLabel?: string;
}

export const IconTextList: React.FC<IconTextListProps> = ({ items, size = 'md', withAnimation = true, ariaLabel }) => (
  <Flex
    animate="animate"
    aria-label={ariaLabel}
    as={motion.div}
    flexDirection="column"
    gap={spacing.s04}
    initial="initial"
    layout="position"
    position="relative"
    variants={withAnimation ? animationVariants : {}}
  >
    <AnimatePresence mode="popLayout">
      {items.map(item => {
        const itemText = typeof item === 'string' ? item : item.text;
        return <IconTextRow {...(typeof item === 'string' ? {} : item)} key={itemText} size={size} text={itemText} />;
      })}
    </AnimatePresence>
  </Flex>
);
